// The release build ships only property search and login, plus what supports searching
// (saved searches, favourites, history, similar offers, settings, sending a site to add). Build with
// REACT_APP_RELEASE_MODE=true to get it; any other value builds the full product.
export const RELEASE_MODE = process.env.REACT_APP_RELEASE_MODE === "true";

export const features = {
  // Owners' listings, finding buyers and the wallet that pays for contacting them.
  marketplace: !RELEASE_MODE,
  messages: !RELEASE_MODE,
  agencies: !RELEASE_MODE,
  admin: !RELEASE_MODE,
  // The alternative landing pages under /v2 and /v3.
  experiments: !RELEASE_MODE,
  // Off until Facebook is set up as a sign-in provider in Firebase project jesteswdomu-aeaa0.
  facebookLogin: false,
  // Off because much of the interface is written in Polish only; with it off everyone gets Polish.
  languageSwitch: false,
};
